export const selectTitle = "Выберите строку";
export const placeholderValue = "Выберите значение...";
